import type { FaireProductEntity } from "../../entity_types/product";

export const p_xjheyjkfha: FaireProductEntity = {
  token: "p_xjheyjkfha",
  type: "product",
  name: "Glitter Edition Dumpling Squishy – Viral Mystery Dumplings",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/77ff39c13d693cae4a0af11873871fd87635bc80aff37570886eb44cb6b8b354.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a77da19cb4f6282af75c0bdb5a142b472cf98685d6d177e4f5e0afc82586e7ba.jpeg",
    "https://cdn.faire.com/fastly/8d1495b5e87c07e3d203335aad9122a44d430bc4568e9cf18e398413fab3c5b3.jpeg",
  ],
  priceDollars: 6.99,
  description:
    "Meet Steam Dumpling Squishy Bunz—the viral, can’t-stop-squeezing mystery dim sum dumpling squishies customers are obsessed with right now. Each “steam bun (aka dumplings)” comes in its own cute dim sum container, making it feel like a fun unboxing moment every time. This is the Glitter Edition Pack. Perfect for checkout counters, toy sections, gift shops, and trend-focused boutiques.\n\nWhat’s Included\n12pcs mystery squishy “steam buns” in a ready-to-display counter box\nAssorted colors/styles (mystery mix)\nEach squishy comes inside a reusable dim sum container\n\nWhy Retailers Love It\nViral + impulse-buy friendly (great for front-of-store displays)\nMystery/unboxing element drives repeat purchases (“I want another color!”)\nGiftable for kids, teens, and adults who love cute collectibles\nGreat as stress relief desk toys and sensory fidgets\n\nProduct Details\nSoft, squeezable squishy texture\n\nRecommended age: 3+\n\nDisplay case included for easy merchandising\nIndividually wrapped dumpling containers.\n\nShips quickly.\n\nPlease Note: This is a listing for the unbranded bead-style squishes, a.k.a. orby-style, not sugar-style. If you like to get sugar style, please check our other listing under maltose.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:29.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
